import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { appSettings } from '@visalex/configs';
import { parseDate } from '@visalex/core/lib/parseDate';

import addMonths from 'date-fns/addMonths';
import isValid from 'date-fns/isValid';

type UsePreserveLastSelectedMonthParams = {
  isDayPickerOpen: boolean;
  defaultMonth?: Date;
  toValue: string;
  fromValue: string;
  format?: string;
};

const nextMonth = addMonths(new Date(), 1);

export const useControlledMonth = ({
  defaultMonth,
  isDayPickerOpen,
  toValue,
  fromValue,
  format = appSettings.dateFormat,
}: UsePreserveLastSelectedMonthParams): [Date, Dispatch<SetStateAction<Date>>] => {
  /** Used to open last selected day month */
  const [month, setMonth] = useState<Date>(defaultMonth || nextMonth);

  useEffect(() => {
    if (isDayPickerOpen) {
      /** If toValue is selected open month in which this range ends */
      if (toValue) {
        /** We should check considering different format */
        const parsedToValue = parseDate(toValue, format);

        parsedToValue && isValid(parsedToValue) && setMonth(new Date(parsedToValue));
      } else if (fromValue) {
        const parsedFromValue = parseDate(fromValue, format);

        parsedFromValue && isValid(parsedFromValue) && setMonth(new Date(parsedFromValue));
      } else setMonth(new Date());
    }
  }, [isDayPickerOpen]);

  return [month, setMonth];
};
